import register from 'ShopUiBundle/modules/app/registry';
import './style.scss';

// tslint:disable-next-line
register('basic-accordion', () => import(/* webpackMode: "lazy" */'./basic-accordion'));
